import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { Campaign } from "../../models/campaign.model";
import { PermissionCheck } from "../../shared/permission";
import { DialogUtils } from "../../helper/dialog.helper";
import { DefaultDialogs } from "../../helper/default-dialogs.helper";
import { NavigationBarHelperService } from "./navigation-bar.helper";
import { ScreenUtils } from "../../helper/screen.helper";
import { Organisation } from "../../models/organisation.model";
import { WhiteLabelDataProvider } from "../../data-provider/white-label.dp";

let SideNavBarComponent = {
    selector: "vcSideNav",
    templateUrl: "/angular/components/navigation/sidenav.component.html",
    bindings: {
        setSelectedOrganisation: "&",
        changeLiveCampaign: "&",
        openProfileMenu: "&",
        profileMenuOpen: "=",
        selectedOrganisation: "=",
        switchLeaderView: "&",
    },
    controller: class SideNavBarController {
        // * bindings for typescript compiler *
        public setSelectedOrganisation: any;
        public changeLiveCampaign: any;
        public selectedOrganisation: any;
        public switchLeaderView: any;
        // ************************************

        public navigationBarService: NavigationBarHelperService;
        public readonly permissionProvider: PermissionCheck;
        public readonly __env: any;

        public campaignDataProvider: CampaignDataProvider;
        public activeCampaign: Campaign;
        public readonly isLeaderView: boolean;
        private readonly dialog: DialogUtils;
        private readonly defaultDialogs: DefaultDialogs;
        private readonly $scope: any;

        public whiteLabelDataProvider: WhiteLabelDataProvider;
        public hover: boolean = false;
        public screen: any;
        public pages: any;
        public pinned: string[];
        public importPageText: string;
        public importPageUrl: string;

        constructor(
            $scope: any,
            ScreenUtils: ScreenUtils,
            WhiteLabelDataProvider: WhiteLabelDataProvider,
            DialogUtils: DialogUtils,
            DefaultDialogs: DefaultDialogs,
            __app_type: string,
            CampaignDataProvider: CampaignDataProvider,
            NavigationBarHelperService: NavigationBarHelperService,
            PermissionCheck: PermissionCheck,
            __env: any
        ) {
            this.dialog = DialogUtils;
            this.screen = ScreenUtils;
            this.$scope = $scope;
            this.whiteLabelDataProvider = WhiteLabelDataProvider;
            this.campaignDataProvider = CampaignDataProvider;
            this.navigationBarService = NavigationBarHelperService;
            this.permissionProvider = PermissionCheck;
            this.isLeaderView = __app_type == "LEADER";
            this.defaultDialogs = DefaultDialogs;
            this.__env = __env;
            this.activeCampaign = this.campaignDataProvider.getActiveCampaign();
            this.activeCampaign.getLocalStorage();

            if (this.activeCampaign.localInfo.sidenav) {
                if (this.activeCampaign.localInfo.sidenav.pinned) {
                    this.pinned = this.activeCampaign.localInfo.sidenav.pinned;
                } else {
                    this.activeCampaign.localInfo.sidenav.pinned = [];
                }

                if (this.activeCampaign.localInfo.sidenav.mini) {
                    this.navigationBarService.mini_side_nav =
                        this.activeCampaign.localInfo.sidenav.mini;
                } else {
                    this.activeCampaign.localInfo.sidenav.mini = false;
                }
            } else {
                this.activeCampaign.localInfo.sidenav = {
                    mini: false,
                    pinned: [],
                };
            }
            this.navigationBarService.mini_side_nav =
                this.activeCampaign.localInfo.sidenav.mini;

            this.activeCampaign.saveLocalStorage();
            this.navigationBarService.setPages(this.permissionProvider);

            this.permissionProvider
                .getFeaturePermissions()
                .then((featurePermission) => {
                    if (
                        this.permissionProvider.hasPermission(
                            "IMPORT_CAMPAIGN_LEVEL"
                        )
                    ) {
                        this.importPageText = "Imports & Exports";
                        this.importPageUrl = "#/voterfiles";
                    } else {
                        this.importPageText = "Exports";
                        this.importPageUrl = "#/exports";
                    }
                });
        }

        getPinnedPages(page: string) {
            let pages = [];

            angular.forEach(this.navigationBarService.pages, (category) => {
                angular.forEach(category.pages, (page) => {
                    if (this.pinned && this.pinned.includes(page.key)) {
                        pages.push(page);
                    }
                });
            });

            return pages;
        }

        isPinnedPage(page: string): boolean {
            if (this.pinned && this.pinned.length) {
                return this.pinned.includes(page);
            }
            return false;
        }

        getPageTarget(page: string): string {
            if (page == "support" || page == "refer") {
                return "_blank";
            }
            return "_self";
        }

        openInviteDialog(step: any, ev: any): void {
            this.dialog
                .show({
                    component: "vc-user-invite",
                    targetEvent: ev,
                    clickOutsideToClose: false,
                    size: "large-plus",
                })
                .then(() => {});
        }

        sideNavHover(page: string) {
            setTimeout(
                () => (this.navigationBarService.mini_side_nav = false),
                100
            );
        }

        sideNavStopHover(page: string) {
            this.navigationBarService.mini_side_nav = true;
        }

        pinPage(page: string) {
            let idx: number = this.pinned.findIndex(
                (element) => element == page
            );

            if (idx > -1) {
                this.pinned.splice(idx, 1);
            } else {
                this.pinned.push(page);
            }

            this.activeCampaign.localInfo.sidenav.pinned = this.pinned;
            this.activeCampaign.saveLocalStorage();
        }

        toggleMiniSideNav(): void {
            this.navigationBarService.mini_side_nav =
                !this.navigationBarService.mini_side_nav;
            this.activeCampaign.getLocalStorage();
            this.activeCampaign.localInfo.sidenav.mini =
                this.navigationBarService.mini_side_nav;
            this.activeCampaign.saveLocalStorage();
        }

        changeCampaign(campaign: Campaign, redirect?: string): void {
            this.changeLiveCampaign({ campaign: campaign, redirect: redirect });
        }

        setSelectedOrg(organisation: Organisation): void {
            this.setSelectedOrganisation({ organisation: organisation });
        }

        switchToLeader(organisation: Organisation): void {
            this.switchLeaderView({ organisation: organisation });
        }
    },
};

angular
    .module("navigation")
    .component(SideNavBarComponent.selector, SideNavBarComponent);
